import React, { useState, useEffect, useRef } from "react";
import "./chart_contentWater4.css";
import bottleImage from "../../../../../assets/conserve-water-chart-04-image-02.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = '64%'; 
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="conserve-water-chart-04-section" ref={chartSectionRef}>
      <div className="conserve-water-chart-04-container">
        <div className="conserve-water-chart-04-container-content-02">
          <img className="conserve-water-chart-04-image" src={bottleImage} alt="Bottle" />
          <div className="conserve-water-chart-04-image-water-effect-02" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Chart;
